export default class VertoVariables {
  static sdpVideoCodecRegex = 'a=rtpmap:(\\d+) H264';
}
